import { useQueryClient } from '../query/queryClient';
import { useCallback, useState } from 'react';
import { createPublicClient, http } from 'viem';
import { mainnet } from 'viem/chains';
const queryKey = (ensAddress) => ['ensName', ensAddress];
export const useSpaceEnsLookup = ({ ethMainnetRpcUrl, townsClient, }) => {
    const qc = useQueryClient();
    const [publicClient] = useState(() => createPublicClient({
        chain: mainnet,
        transport: ethMainnetRpcUrl ? http(ethMainnetRpcUrl) : http(),
    }));
    const getEnsData = useCallback(async (userId, ensAddress, fetchOnCacheMiss = true) => {
        if (!ensAddress) {
            return;
        }
        const ensName = qc.getQueryData(queryKey(ensAddress));
        if (!ensName) {
            if (!fetchOnCacheMiss) {
                return;
            }
            const response = await publicClient.getEnsName({
                address: ensAddress,
            });
            if (response) {
                qc.setQueryData(queryKey(ensAddress), response);
                return { ensAddress, ensName: response };
            }
        }
        const _ensName = ensName;
        const linkedWallets = await townsClient?.getLinkedWalletsWithDelegations(userId);
        const isOwned = linkedWallets?.includes(ensAddress);
        return isOwned
            ? {
                ensAddress,
                ensName: _ensName,
            }
            : undefined;
    }, [publicClient, qc, townsClient]);
    return { getEnsData };
};
//# sourceMappingURL=use-ens-lookup.js.map